'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.connectToLegacyApp = connectToLegacyApp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _constants = require('ui/signature-modal/constants');

var _constants2 = _interopRequireDefault(_constants);

var _get = require('lodash/object/get');

var _get2 = _interopRequireDefault(_get);

var _errors = require('signer/api/errors');

var _errors2 = _interopRequireDefault(_errors);

var _reactIntl = require('react-intl');

var _signature = require('hellosign/models/signature');

var _signature2 = _interopRequireDefault(_signature);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var PropTypes = _react2['default'].PropTypes;

/**
 * Legacy application connector
 *
 * This is a wrapper component that handles the business logic for the legacy
 * application.  It is, for the most part, a direct rip of the logic in the
 * previous signature modal.  We prepare and handle all state in this component
 * and pass down any props needed to the "detached" signature modal.
 */

function connectToLegacyApp(SignatureModal) {
    return _react2['default'].createClass({
        displayName: 'connectToLegacyApp(SignatureModal)',

        propTypes: {

            /**
             * Application
             */
            app: PropTypes.object.isRequired,

            /**
             * Text to be displayed on the CTA (only when canInsertEverywhere=false)
             */
            buttonText: PropTypes.string,

            /**
             * Whether to show the option to insert everywhere
             */
            canInsertEverywhere: PropTypes.bool,

            /**
             * Email guid for signature upload,
             */
            emailGuid: PropTypes.string,

            /**
             * Email address to send signatures to
             */
            emailUploadAddress: PropTypes.string,

            /**
             * Whether it should have mobile behavior
             */
            isMobile: PropTypes.bool,

            /**
             * The tab shown at first (see SignatureModal.TAB_*)
             */
            initialTab: PropTypes.string,

            /**
             * True if the modal is within the embedded context
             */
            isEmbedded: PropTypes.bool,

            /**
             * DO NOT USE
             *
             * This is here as a workaround for the smart forms demo.  It should not be
             * used for other apps.
             */
            onBeforeInsert: PropTypes.func,

            /**
             * Called when the signature modal is closed by the user
             */
            onClose: PropTypes.func,

            /**
             * Called when the user has selected a signature for action(signature, insertEverywhere)
             */
            onComplete: PropTypes.func,

            /**
             * Define which tabs should be shown { tabId => true/false }
             */
            settings: PropTypes.object,

            /**
             * Signature or initials (see SignatureModal.TYPE_*)
             */
            type: _react2['default'].PropTypes.string
        },

        getDefaultProps: function getDefaultProps() {
            return {
                initialTab: _constants2['default'].TAB_SAVED
            };
        },
        getInitialState: function getInitialState() {
            return Object.assign({
                isCreatingDrawnSignature: false,
                isCreatingTypedSignature: false,
                isUploadingSignature: false,
                isCheckingEmailedSignatureStatus: false,
                selectedSavedSignature: null,
                uploadedSignature: null,
                emailedSignature: null
            }, this.getStates());
        },
        componentDidMount: function componentDidMount() {
            var _this = this;

            this.mounted = true;

            var isLoading = this.isLoading();
            if (isLoading) {
                // Load the user signatures (will only fetch them if not already cached)
                this.props.app.user.getSignatures(this.props.type).load().then(function () {

                    if (_this.mounted) {
                        _this.setState(_this.getStates());
                    }
                });
            }
        },
        componentWillUnmount: function componentWillUnmount() {
            this.mounted = false;
        },
        componentWillReceiveProps: function componentWillReceiveProps(newProps) {
            this.setState(this.getStates(newProps));
        },
        createSignature: function createSignature(signatureData) {
            return this.props.app.user.getSignatures(this.props.type).add(signatureData);
        },
        editSignature: function editSignature(signature, signatureData) {
            // Set parameters from edit pane
            signature.setEditParams(signatureData);
            // Then get list of signatures, and use the edit endpoint to add
            return this.props.app.user.getSignatures(this.props.type).addFromEdit(signature);
        },
        getEmailGuid: function getEmailGuid() {
            var guid = this.props.emailGuid;

            if (!guid) {
                guid = this.props.type === _constants2['default'].TYPE_SIGNATURE ? (0, _get2['default'])(this.props.app, ['emailGuids', 'signature_email_guid']) : (0, _get2['default'])(this.props.app, ['emailGuids', 'initials_email_guid']);
            }

            return guid;
        },
        getEmailUploadAddress: function getEmailUploadAddress() {
            return this.props.emailUploadAddress || this.props.app.emailUploadAddress;
        },
        getEnabledTabs: function getEnabledTabs() {
            var settings = this.props.settings;


            return _constants2['default'].TABS.filter(function (tabId) {
                return settings[tabId] !== false;
            });
        },
        getInitialTab: function getInitialTab(props, signatures) {

            var tabId = props.initialTab;
            var hasVisibleTab = false;
            var i;

            for (i in _constants2['default'].TABS) {
                if (props.settings[_constants2['default'].TABS[i]] !== false) {
                    hasVisibleTab = true;
                    break;
                }
            }

            if (!hasVisibleTab) {
                // No visible tab due to restrictions from settings
                tabId = _constants2['default'].TAB_DRAW;
            } else if (tabId === _constants2['default'].TAB_SAVED && signatures.length === 0) {
                // Default to the next visible tab if there aren't any saved signatures
                for (i in _constants2['default'].TABS) {
                    if (_constants2['default'].TABS[i] !== _constants2['default'].TAB_SAVED && props.settings[_constants2['default'].TABS[i]] !== false) {
                        tabId = _constants2['default'].TABS[i];
                        break;
                    }
                }
            } else if (props.settings[tabId] === false) {
                // Select the first visible tab if the specified can't be displayed
                for (i in _constants2['default'].TABS) {
                    if (_constants2['default'].TABS[i] !== tabId && props.settings[_constants2['default'].TABS[i]] !== false) {
                        tabId = _constants2['default'].TABS[i];
                        break;
                    }
                }
            }

            return tabId;
        },
        getInitialTypeInValue: function getInitialTypeInValue() {
            var _props = this.props,
                app = _props.app,
                type = _props.type;

            var user = app.user;
            var fullName = user.getFullName();
            var value = (type === _constants2['default'].TYPE_INITIALS ? user.getInitials() : fullName) || '';

            return value;
        },
        getLoaderContent: function getLoaderContent() {
            var _state = this.state,
                isCreatingDrawnSignature = _state.isCreatingDrawnSignature,
                isCreatingTypedSignature = _state.isCreatingTypedSignature;


            if (isCreatingDrawnSignature || isCreatingTypedSignature) {
                return _react2['default'].createElement(_reactIntl.FormattedMessage, {
                    id: 'signModal.loader.text',
                    values: { type: this.props.type }
                });
            }
        },
        getStates: function getStates(newProps) {
            var props = newProps || this.props;
            var user = props.app.user;
            var signatures = user.getSignatures(props.type);
            var isLoading = !signatures.data || signatures.loading === true;

            var hasSignatures = signatures && signatures.length > 0;
            var selectedSignatureIndex = 0;
            if (window.primarySignatureGuid && hasSignatures) {
                for (var i = 0; i < signatures.length; i++) {
                    if (signatures[i].guid === window.primarySignatureGuid) {
                        selectedSignatureIndex = i;
                        break;
                    }
                }
            }

            var selectedSavedSignature = hasSignatures ? signatures[selectedSignatureIndex] : null;

            return {
                isLoadingSignatures: isLoading,
                'selectedTab': isLoading ? null : this.getInitialTab(props, signatures),
                'savedSignatures': isLoading ? [] : signatures,
                selectedSavedSignature: selectedSavedSignature
            };
        },
        handleCheckEmailedSignatureStatus: function handleCheckEmailedSignatureStatus() {
            var _props2 = this.props,
                type = _props2.type,
                app = _props2.app;

            var emailGuid = this.getEmailGuid();

            this.setState({ isCheckingEmailedSignatureStatus: true });

            var sig = _signature2['default'].create({
                'notifier': app.notifier,
                'emailGuid': emailGuid,
                'type': type,
                'createType': _constants2['default'].SIGNATURE_TYPE_EMAIL
            });

            var callback = function (err, data) {

                if (err) {
                    this.handleError(err);
                }

                if (data.status) {

                    if (data.status == 'pending') {

                        // Repeat the cycle as retries permit
                        this.retries++;
                        if (this.retries < this.retryLimit) {
                            setTimeout(function () {
                                sig.checkEmailSignatureStatus().then(callback.bind(this, void 0))['catch'](callback);
                            }, this.retryPeriod);
                        } else {
                            this.setState({ isCheckingEmailedSignatureStatus: false });
                            this.handleError(new Error('Retries timed out'));
                        }
                    }

                    if (data.status == 'ok') {

                        // End and assign id
                        sig.guid = data.signature_guid;
                        sig.width = data.width;
                        sig.height = data.height;

                        this.setState({
                            emailedSignature: sig,
                            isCheckingEmailedSignatureStatus: false
                        });

                        // Refresh Guids
                        this.refreshGuids(data);
                    }

                    if (data.status == 'error') {
                        this.refreshGuids(data);
                        this.handleError(new Error('Server Error'));

                        this.setState({ isCheckingEmailedSignatureStatus: false });
                    }
                }
            }.bind(this);

            sig.checkEmailSignatureStatus().then(function () {
                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }

                return callback.apply(undefined, [undefined].concat(args));
            });
        },


        /**
         * This is not the ideal way to handle this.  In the type-in tab, we're
         * first trying to save the signature request to see if we're online or
         * not.  We do this because if this request fails, we'll show a nice
         * error message to the user.  But, it's only handled for mobile and
         * only when there's a signature request present.  It's very specialized
         * for this one scenario.  Leaving it in for now for legacy reasons.
         */
        handleCheckNetworkHealth: function handleCheckNetworkHealth(cb) {
            if (this.props.isMobile && this.props.app.signatureRequest) {
                // Make sure we have connectivity before loading fonts on mobile
                // NOTE: We need to trigger a save beforehand because loading font does not
                // go through the API service and will not bring up the connectivity screen
                // when network is down.
                this.props.app.signatureRequest.save(cb);
            } else {
                cb();
            }
        },
        handleDrawnSignatureInsert: function handleDrawnSignatureInsert(signatureData, insertEverywhere) {
            var _this2 = this;

            this.setState({ isCreatingDrawnSignature: true });

            this.createSignature(signatureData).then(function (signature) {
                _this2.setState({ isCreatingDrawnSignature: false });
                _this2.props.onComplete(signature, insertEverywhere);
            })['catch'](function (error) {
                _this2.setState({ isCreatingDrawnSignature: false });
                var errorMessage = void 0;

                // Lodash `get` is a safe way to dig deeply into the error
                // object.  If any of these properties are not defined there
                // will be no error code and we'll just display a general
                // message.
                var originalCode = (0, _get2['default'])(error, ['error', 'data', 'original_code']);

                if (originalCode) {
                    errorMessage = _this2.props.intl.formatMessage({ id: 'signModal.drawn.error.' + originalCode }, { 'type': _this2.props.type });
                } else {
                    errorMessage = _this2.props.intl.formatMessage({ id: 'error.general.message' });
                }

                _this2.handleError({ message: errorMessage });
            });
        },
        handleEmailedSignatureInsert: function handleEmailedSignatureInsert(signatureData, insertEverywhere) {
            var _this3 = this;

            var emailedSignature = this.state.emailedSignature;

            var finalSignatureData = _extends({}, emailedSignature.data, {
                guid: emailedSignature.guid
            }, signatureData);

            this.setState({ isCreatingEmailedSignature: true });

            this.editSignature(emailedSignature, finalSignatureData).then(function (signature) {
                _this3.setState({ isCreatingEmailedSignature: false });
                _this3.props.onComplete(signature, insertEverywhere);
            })['catch'](function (e) {
                return _this3.handleError(e);
            });
        },
        handleError: function handleError(error) {
            this.setState({ error: error });

            if (error.code === _errors2['default'].NETWORK || error.code === _errors2['default'].CREDENTIALS) {
                // No need to trigger error reporting in this case since a special error screen
                // will be shown instead.
                return;
            }

            // Right now, tabbed error handling is only turned on for Desktop clients
            if (!this.props.isMobile) {
                this.selectTab(_constants2['default'].TAB_ERROR);
            } else {
                console.error('Signature Modal Error: ' + (error ? error.message : ''));
            }
        },
        handleSavedSignatureRemove: function handleSavedSignatureRemove(signature) {
            var _this4 = this;

            if (!window.confirm(this.props.intl.formatMessage({ id: 'signModal.saved.delete.confirmMessage.' + this.props.type }))) {
                return;
            }
            var signatures = this.state.savedSignatures;
            var selectedSignature = this.state.selectedSavedSignature;

            signature.remove(function (error) {
                if (error) _this4.props.onError(error);else {

                    // If the signature we're removing is the current selected sig
                    if (signature.guid === selectedSignature.guid) {

                        // If there are signatures other than the one that just got
                        // deleted
                        if (signatures.length > 1) {

                            // Find the signature in the state that matches the
                            // selected signature
                            var selectedIndex = 0;
                            for (var i = 0; i < signatures.length; i++) {
                                if (signatures[i].guid === selectedSignature.guid) {
                                    selectedIndex = i;
                                    break;
                                }
                            }

                            // Make the selected signature the signature after the
                            // removed signature
                            selectedSignature = signatures[selectedIndex + 1];
                            if (selectedSignature === undefined) {
                                selectedSignature = signatures[selectedIndex - 1];
                            }

                            // TODO - remove this - this is breaking encapsulation majorly. This sort
                            // of logic should be within the signatures collection (CC)
                            signatures.splice(selectedIndex, 1);
                        } else {

                            // The last signature just got deleted so pop the last one out
                            signatures.splice(0, 1);
                            selectedSignature = null;
                            window.primarySignatureGuid = void 0;
                        }
                    }

                    var sigReq = _this4.props.app.signatureRequest;
                    var selectedSig;
                    if (sigReq) selectedSig = sigReq.getSelectedSignature(_this4.props.type);
                    if (selectedSig && selectedSig.guid === signature.guid) {
                        // Reset the selected signature if it'a been deleted
                        sigReq.setSelectedSignature(_this4.props.type, null);
                    }

                    _this4.setState({
                        'savedSignatures': signatures,
                        selectedSavedSignature: selectedSignature
                    });
                }
            });
        },
        handleSignatureRotate: function handleSignatureRotate(signature) {
            signature.rotate();
        },
        handleSavedSignatureSelect: function handleSavedSignatureSelect(signature) {
            this.setState({
                selectedSavedSignature: signature
            });
        },
        handleSignatureData: function handleSignatureData(signatureData, insertEverywhere) {
            var type = signatureData.create_type_code;

            // Keeps support for the smart-forms demo

            if (typeof this.props.onBeforeInsert === 'function') {
                return this.props.onBeforeInsert(signatureData, insertEverywhere);
            }

            if (type === _constants2['default'].SIGNATURE_TYPE_CANVAS) {
                return this.handleDrawnSignatureInsert(signatureData, insertEverywhere);
            } else if (type === _constants2['default'].SIGNATURE_TYPE_TYPED) {
                return this.handleTypedSignatureInsert(signatureData, insertEverywhere);
            } else if (type === _constants2['default'].SIGNATURE_TYPE_UPLOAD) {
                return this.handleUploadedSignatureInsert(signatureData, insertEverywhere);
            } else if (type === _constants2['default'].SIGNATURE_TYPE_EMAIL) {
                return this.handleEmailedSignatureInsert(signatureData, insertEverywhere);
            }
        },
        handleSignatureUpload: function handleSignatureUpload(data) {
            var _this5 = this;

            return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var sig;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this5.setState({ isUploadingSignature: true });

                                sig = _signature2['default'].create({
                                    'notifier': _this5.props.app.notifier,
                                    'file': data
                                });


                                sig.createType = _constants2['default'].SIGNATURE_TYPE_UPLOAD;
                                sig.type = _this5.props.type;

                                _context.prev = 4;
                                _context.next = 7;
                                return sig.save({ handleError: false });

                            case 7:

                                _this5.setState({
                                    uploadedSignature: sig
                                });

                                _context.next = 13;
                                break;

                            case 10:
                                _context.prev = 10;
                                _context.t0 = _context['catch'](4);

                                _this5.handleError(_context.t0);

                            case 13:

                                _this5.setState({ isUploadingSignature: false });

                            case 14:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this5, [[4, 10]]);
            }))();
        },
        handleTypedSignatureInsert: function handleTypedSignatureInsert(signatureData, insertEverywhere) {
            var _this6 = this;

            this.setState({ isCreatingTypedSignature: true });

            this.createSignature(signatureData).then(function (signature) {
                _this6.setState({ isCreatingTypedSignature: false });
                _this6.props.onComplete(signature, insertEverywhere);
            })['catch'](function (error) {
                // The error here may not be parseable, so if not just
                // display the general message
                var err = error.response ? JSON.parse(error.response.text) : error;
                var msg = err.response ? _this6.props.intl.formatMessage({ id: 'signModal.typed.error.' + err.name }) : _this6.props.intl.formatMessage({ id: 'error.general.message' });
                _this6.handleError({ 'message': msg });
            });
        },
        handleUploadedSignatureInsert: function handleUploadedSignatureInsert(signatureData, insertEverywhere) {
            var _this7 = this;

            var uploadedSignature = this.state.uploadedSignature;

            var finalSignatureData = _extends({}, uploadedSignature.data, {
                guid: uploadedSignature.guid
            }, signatureData);

            this.setState({ isCreatingUploadedSignature: true });

            this.editSignature(uploadedSignature, finalSignatureData).then(function (signature) {
                _this7.setState({ isCreatingUploadedSignature: false });
                _this7.props.onComplete(signature, insertEverywhere);
            })['catch'](function (e) {
                return _this7.handleError(e);
            });
        },
        isLoading: function isLoading() {
            var _state2 = this.state,
                isCreatingDrawnSignature = _state2.isCreatingDrawnSignature,
                isCreatingTypedSignature = _state2.isCreatingTypedSignature,
                isLoadingSignatures = _state2.isLoadingSignatures;


            return isLoadingSignatures || isCreatingDrawnSignature || isCreatingTypedSignature;
        },
        refreshGuids: function refreshGuids(data) {
            if (data.hasOwnProperty('new_email_guid')) {

                var newGuid = data.new_email_guid;

                if (typeof this.props.app.emailGuids === 'undefined') {
                    this.props.app.emailGuids = [];
                }
                if (this.props.type === _constants2['default'].TYPE_SIGNATURE) {
                    this.props.app.emailGuids.signature_email_guid = newGuid;
                } else {
                    this.props.app.emailGuids.initials_email_guid = newGuid;
                }
            }
        },


        retries: 0,
        retryLimit: _constants2['default'].EMAIL_STATUS_MAX_RETRIES,
        retryPeriod: _constants2['default'].EMAIL_STATUS_RETRY_PERIOD,

        selectSavedSignature: function selectSavedSignature(signature) {
            this.setState({
                'selectedSignature': signature
            });
        },
        selectTab: function selectTab(tabId) {
            this.setState({
                'selectedTab': tabId
            });
        },
        render: function render() {
            var _state3 = this.state,
                error = _state3.error,
                savedSignatures = _state3.savedSignatures,
                selectedSavedSignature = _state3.selectedSavedSignature,
                selectedTab = _state3.selectedTab,
                uploadedSignature = _state3.uploadedSignature,
                isUploadingSignature = _state3.isUploadingSignature,
                isCheckingEmailedSignatureStatus = _state3.isCheckingEmailedSignatureStatus,
                emailedSignature = _state3.emailedSignature;
            var _props3 = this.props,
                app = _props3.app,
                buttonText = _props3.buttonText,
                canInsertEverywhere = _props3.canInsertEverywhere,
                intl = _props3.intl,
                isEmbedded = _props3.isEmbedded,
                isMobile = _props3.isMobile,
                onClose = _props3.onClose,
                onComplete = _props3.onComplete,
                settings = _props3.settings,
                type = _props3.type;


            var loading = this.isLoading();
            var loaderContent = this.getLoaderContent();
            var emailGuid = this.getEmailGuid();
            var emailUploadAddress = this.getEmailUploadAddress();
            var enabledTabs = this.getEnabledTabs();
            var filteredSavedSignatures = savedSignatures.filter(function (sig) {
                return settings[sig.createType] !== false;
            });

            return _react2['default'].createElement(SignatureModal, {
                buttonText: buttonText,
                canInsertEverywhere: canInsertEverywhere,
                emailedSignature: emailedSignature,
                emailGuid: emailGuid,
                emailUploadAddress: emailUploadAddress,
                enabledTabs: enabledTabs,
                error: error,
                getSignatureUrl: function getSignatureUrl(signature) {
                    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                        args[_key2 - 1] = arguments[_key2];
                    }

                    return signature.getUrl.apply(signature, args);
                },
                initialTypeInValue: this.getInitialTypeInValue(),
                isCheckingEmailedSignatureStatus: isCheckingEmailedSignatureStatus,
                isEmbedded: isEmbedded,
                isMobile: isMobile || app.isMobile,
                intl: intl,
                isUploadingSignature: isUploadingSignature,
                loaderContent: loaderContent,
                loading: loading,
                onCheckEmailedSignatureStatus: this.handleCheckEmailedSignatureStatus,
                onClose: onClose,
                onError: this.handleError,
                onInsert: onComplete,
                onCheckNetworkHealth: this.handleCheckNetworkHealth,
                onRotateSignature: this.handleSignatureRotate,
                onSignatureData: this.handleSignatureData,
                onSavedSignatureRemove: this.handleSavedSignatureRemove,
                onSavedSignatureSelect: this.handleSavedSignatureSelect,
                onTabSelect: this.selectTab,
                onUploadSignature: this.handleSignatureUpload,
                savedSignatures: filteredSavedSignatures,
                settings: settings,
                selectedSavedSignature: selectedSavedSignature,
                selectedTab: selectedTab,
                type: type,
                uploadedSignature: uploadedSignature
            });
        }
    });
}

exports['default'] = connectToLegacyApp;


/*****************
 ** WEBPACK FOOTER
 ** ./src/signer/components/common/signature-modal/legacy-app-connector.jsx
 ** module id = 781
 ** module chunks = 0 1
 **/